module.exports = __webpack_public_path__ + "static/media/person.7c6664ba.webm";